
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/heiskort",
      function () {
        return require("private-next-pages/[region]/heiskort.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/heiskort"])
      });
    }
  